import React from 'react';
import styled from 'styled-components';
import { SectionContainer } from '../../../aboutUs/styles';
import { COLORS, device, FONTS } from '../../../../constants';
import { Box, Text } from '../../../../components';
import SectionImage from '../Images/SectionImage';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  screenshot: string;
  description: string;
}

export const ProjectDescription: React.FC<DivProps> = ({
  screenshot,
  description,
  ...props
}) => {
  return (
    <SectionContainer color={COLORS.LIGHT_BG_COLOR}>
      <Box>
        <DescriptionContainer {...props}>
          <ScreenshotContainer>
            <SectionImage src={screenshot} alt="Description screenshot" />
          </ScreenshotContainer>
          <DescriptionTextContainer>
            <Text
              text={description}
              fontFamily={FONTS.TITLE}
              size={24}
              lineHeight={32}
            />
          </DescriptionTextContainer>
        </DescriptionContainer>
      </Box>
    </SectionContainer>
  );
};

const DescriptionContainer = styled.div`
  display: grid;
  align-content: stretch;
  grid-template-columns: 869px 432px;
  grid-template-rows: 932px;
  column-gap: 88px;
  align-items: center;
  @media screen and ${device.xl} {
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr;
  }
  @media screen and ${device.md} {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    align-items: start;
  }
  @media screen and ${device.sm} {
    grid-template-columns: 1fr;
  }
`;

const ScreenshotContainer = styled.div`
  @media screen and ${device.sm} {
    width: 80%;
    margin: 0 auto;
  }
  @media screen and ${device.xs} {
    width: 100%;
  }
`;
const DescriptionTextContainer = styled.div`
  max-width: 432px;
  @media screen and ${device.md} {
    max-width: none;
    > h4 {
      font-size: 18px;
      line-height: 26px;
    }
  }
`;
